module.exports = __webpack_public_path__ + "img/bank-19-post.e1e37507.svg";